import Vue from "vue";

class ReembolsoService {
  async busca(
    uf,
    produto,
    tipo_plano,
    contratacao,
    cidade,
    compulsorio,
    coparticipacao,
    acomodacao,
    credenciado,
    planos,
    administradora,
    entidade
  ) {
    try {
      let params = [
        { key: "compulsorio", value: compulsorio },
        { key: "coparticipacao", value: coparticipacao },
        { key: "acomodacao", value: acomodacao },
        { key: "credenciado", value: credenciado },
        { key: "administradora", value: administradora },
        { key: "entidade", value: entidade }
      ]
        .map(p => p.key + "=" + (p.value || ""))
        .join("&");
      let paramsPlanos = planos
        ? params + "&" + planos.map(plano => "planos[]=" + plano).join("&")
        : params;
      const response = await Vue.prototype.$http.get(
        `reembolsos/${uf}/${produto}/${tipo_plano}/${contratacao}/${cidade ||""}?${paramsPlanos}`
      )
      return await response.data;
    } catch (error) {
      throw error
    }
  }
}

export default new ReembolsoService();
